import React, { Suspense, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { isAuthoritiesInvalid, isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { bookedPageViewTypes } from '../MyLiveSessions/my-live-sessions-utils'
// import { PublicAppHomepage } from ''
import { EmptyLoadingScreen } from '../Loaders'
import { PublicAppHomepage } from './PublicAppHomepage'
import { getFirebaseAuth } from 'src/firebase'
import { signOut } from 'firebase/auth'

export default function AppHomepage() {
  const token = localStorage.getItem('token')
  const authorities = localStorage.getItem('authorities')

  // Clear Firebase auth state if app token is missing but Firebase has a user
  // This fixes the issue where Firebase thinks user is authenticated but app doesn't
  useEffect(() => {
    const checkAndClearFirebaseAuth = async () => {
      if (isTokenInvalidOrAbsent(token) || isAuthoritiesInvalid(authorities)) {
        // App thinks user is not authenticated, but Firebase might still have auth state
        try {
          const auth = getFirebaseAuth()
          const currentUser = auth.currentUser
          if (currentUser) {
            await signOut(auth)
          }
        } catch (error) {
          // Silently handle any errors during sign out
          console.warn('Error clearing Firebase auth state:', error)
        }
      }
    }
    checkAndClearFirebaseAuth()
  }, [token, authorities])

  const MyLiveSessionsWrapper = React.lazy(() =>
    import('../../components/MyLiveSessions/MyLiveSessionWrapper'),
  )
  const UserActivityPage = React.lazy(() =>
    import('../../components/UserActivityPage/UserActivityWebWrapper.jsx'),
  )
  const LeaderboardPage = React.lazy(() => import('../../components/LeaderboardPage'))
  const TilesPage = React.lazy(() => import('../../components/TilesPage'))
  const GiftCardRedeem = React.lazy(() => import('../../../GiftCard/components/GiftCardRedeem'))
  const ConsumerProfilePage = React.lazy(() => import('../../components/ConsumerProfilePage'))
  const CreatePlanPage = React.lazy(() => import('../../components/MyPlansPage/CreatePlanPage'))
  const MyPlansPage = React.lazy(() => import('../../components/MyPlansPage'))
  const RedirectToUserActivityPage = React.lazy(() =>
    import('../../components/UserActivityPage/RedirectToUserActivityPage'),
  )
  const ConsumerHomepage = React.lazy(() => import('../ConsumerHomepage'))
  const SelfPracticePage = React.lazy(() => import('../TilesPagePractice'))
  const TilesPagePatient = React.lazy(() => import('../TilesPagePatient/TilesPagePatient'))
  // const PublicAppHomepage = React.lazy(() => import('./PublicAppHomepage'))

  return (
    <>
      <Suspense fallback={<EmptyLoadingScreen />}>
        {isTokenInvalidOrAbsent(token) || isAuthoritiesInvalid(authorities) ? (
          <PublicAppHomepage />
        ) : (
          <Routes>
            <Route element={<LeaderboardPage />} path="leaderboard" />
            <Route element={<GiftCardRedeem />} path="redeem" name="Gift Card Redeem" />
            <Route path="/" name="Consumer Homepage" element={<ConsumerHomepage />}>
              {/* NOTE :: any route addition here should be added to noRedirectToTiles Array in consumer homepage. idea is to remove everything except tiles from here. there are data dependencies so not moving everything now. use redux */}
              <Route element={<ConsumerProfilePage />} path="profile" />
              <Route
                element={<MyLiveSessionsWrapper pageViewType={bookedPageViewTypes.new} />}
                path={`my-live-sessions/${bookedPageViewTypes.new}`}
              />
              <Route
                element={
                  <MyLiveSessionsWrapper pageViewType={bookedPageViewTypes.booked_sessions} />
                }
                path={`my-live-sessions/${bookedPageViewTypes.booked_sessions}`}
              />
              <Route
                element={
                  <MyLiveSessionsWrapper pageViewType={bookedPageViewTypes.booked_sessions} />
                }
                path={`my-live-sessions/${bookedPageViewTypes.booked_sessions}/:eventId`}
              />
              <Route
                element={<Navigate to={`${bookedPageViewTypes.booked_sessions}`} />}
                path="my-live-sessions"
              />
              <Route element={<CreatePlanPage />} path="my-plan/create" />
              <Route element={<MyPlansPage />} path="my-plan" />
              <Route element={<RedirectToUserActivityPage />} path="activity-plan/:planId" />
              <Route element={<UserActivityPage idType="slug" />} path="my-activity/:planId" />
              <Route element={<UserActivityPage idType="planId" />} path="my-activity/id/:planId" />
              <Route element={<SelfPracticePage />} path="tile/practice" />
              <Route element={<TilesPagePatient />} path="tile/patient-home" />
              <Route element={<TilesPage />} path="tile/:tileId/:policyId" />
              <Route element={<TilesPage />} path="tile/:tileId" />
              <Route element={<TilesPage />} path="" />
              <Route element={<UnknownLoggedInRouteHandlerComponent />} path="*" />
            </Route>
          </Routes>
        )}
      </Suspense>
    </>
  )
}

const UnknownLoggedInRouteHandlerComponent = () => {
  // unknown routes already being taken care of - in consumer homepage - being redirected to tiles.
  // wrong behavior - to be fixed
  return <div></div>
}
